import { Box, CircularProgress, Divider, Typography } from "@mui/material"
import { useSelector } from "react-redux"
import {
  OpportunityDetailLoadingWrapper,
  OpportunityDetailWrapper,
} from "./Atom"
import moment from "moment"
import { firstCap } from "../../../../helper/utils"

const MetricOpportunityDetail = () => {
  const metricOpportunityDetail = useSelector((state: any) => {
    return state.metric.metricOpportunityDetail
  })

  return (
    <>
      {metricOpportunityDetail ? (
        <OpportunityDetailWrapper>
          <Typography fontSize={14} fontWeight={500}>
            {firstCap(metricOpportunityDetail?.opportunity_status)}
          </Typography>
          <Box>
            <Typography fontSize={10} fontWeight={400}>
              Start Date
            </Typography>
            <Typography fontSize={14} fontWeight={500}>
              {moment(metricOpportunityDetail?.start_date).format("YYYY/MM/DD")}
            </Typography>
          </Box>
          <Box>
            <Typography fontSize={10} fontWeight={400}>
              End Date
            </Typography>
            <Typography fontSize={14} fontWeight={500}>
              {moment(metricOpportunityDetail?.end_date).format("YYYY/MM/DD")}
            </Typography>
          </Box>
          <Box>
            <Typography fontSize={10} fontWeight={400}>
              Set By
            </Typography>
            <Typography fontSize={14} fontWeight={500}>
              {metricOpportunityDetail?.creator_name}
            </Typography>
          </Box>
          <Box>
            <Typography fontSize={10} fontWeight={400}>
              Last Status Changed On
            </Typography>
            <Typography fontSize={14} fontWeight={500}>
              {moment(metricOpportunityDetail?.last_status_changed_on).format(
                "YYYY/MM/DD",
              )}
            </Typography>
          </Box>
        </OpportunityDetailWrapper>
      ) : (
        <OpportunityDetailLoadingWrapper>
          <CircularProgress sx={{ color: "#FFFFFF" }} />
        </OpportunityDetailLoadingWrapper>
      )}
    </>
  )
}

export default MetricOpportunityDetail
